<template>
  <v-card class="mb-3" outlined>
    <div class="d-flex flex-no-wrap justify-space-between">
      <div>
        <v-card-title class="title">Tiket {{ ticketName }}</v-card-title>
        <v-card-subtitle>
          <div class="mb-2" v-if="price != 0">
            {{ price | currency }}
          </div>
          <div class="mb-2" v-else>GRATIS</div>
          <v-chip v-if="is_certificate" class="mr-2" color="primary" small>
            Sertifikat
          </v-chip>
          <!--          <v-chip v-if="is_snack" small color="primary"> Snack</v-chip>-->
        </v-card-subtitle>
      </div>

      <div>
        <v-avatar class="ma-3" size="100" tile>
          <v-btn
            v-if="quota_remain > 0"
            :to="/checkout/ + id"
            color="primary"
            >{{ price != 0 ? 'BELI' : 'DAFTAR' }}</v-btn
          >
          <v-btn v-else disabled>HABIS</v-btn>
        </v-avatar>
        <p class="text-right mr-4 red--text" v-if="quota_remain <= 5">
          {{ quota_remain }} tiket tersisa
        </p>
      </div>
    </div>
  </v-card>
</template>

<script>
export default {
  name: 'TicketCard',
  props: {
    id: Number,
    ticketName: String,
    price: Number,
    is_certificate: Number,
    is_snack: Number,
    quota: Number,
    quota_sold: Number,
    quota_remain: Number,
    route: Object,
  },
};
</script>

<style scoped></style>
